import { useMemo } from "react";
import AppConfig from "util/AppConfig";
import Version from "util/Version";
const defaultResourcesUrls = {
  stream_rule_matcher_code: `https://github.com/Graylog2/graylog2-server/tree/${Version.getMajorAndMinorVersion()}/graylog2-server/src/main/java/org/graylog2/streams/matchers`,
  contact_support: "https://support.graylog.org/portal",
  contact_us: "https://www.graylog.org/community-support/",
  marketplace: "https://marketplace.graylog.org/"
};
const useResourceCustomization = (brandingKey) => {
  const resources = useMemo(() => {
    var _a, _b, _c, _d;
    const customResources = (_d = (_c = (_b = (_a = AppConfig) == null ? void 0 : _a.branding) == null ? void 0 : _b.call(_a)) == null ? void 0 : _c.resources) != null ? _d : {};
    return Object.fromEntries(
      Object.entries(defaultResourcesUrls).map(([key, defaultUrl]) => {
        var _a2;
        const resource = customResources == null ? void 0 : customResources[key];
        return [key, { enabled: (resource == null ? void 0 : resource.enabled) !== false, url: (_a2 = resource == null ? void 0 : resource.url) != null ? _a2 : defaultUrl }];
      })
    );
  }, []);
  return resources[brandingKey];
};
export default useResourceCustomization;
